import './floatingFeedback.scss';

import { CSSTransition, TransitionGroup } from 'react-transition-group';
import React, { useContext, useEffect } from 'react';

import { feedbackContext } from '../../context/feedback/feedbackContext';

function SingleFeedback({ index, alert }) {
    let message = alert.message;
    let classes = '';

    const { deleteAlert } = useContext(feedbackContext);

    switch (alert.status) {
        case 'success':
            classes = 'success';
            break;
        case 'error':
            classes = 'error';
            break;
        default:
            classes = 'default';
    }

    // Text can be found at response.message
    if (message && message.message) {
        message = message.message;
    }

    // Errors are sometimes objects
    if (typeof message === 'object') {
        message = JSON.stringify(message);
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            deleteAlert(index);
        }, 5000);
        return () => clearTimeout(timer);
    });

    return (
        <div
            onClick={() => deleteAlert(index)}
            className={`singleFeedback ${classes}`}
        >
            {message}
        </div>
    );
}

export function FloatingFeedback({ className }) {
    const { alerts } = useContext(feedbackContext);

    return (
        <div className={`feedbackContainer ${className}`}>
            <div className='feedbackContent'>
                <TransitionGroup>
                    {alerts.length &&
                        alerts.map((alert, index) => (
                            <CSSTransition
                                key={index}
                                timeout={300}
                                classNames='item'
                            >
                                <SingleFeedback alert={alert} index={index} />
                            </CSSTransition>
                        ))}
                </TransitionGroup>
            </div>
        </div>
    );
}
